import axios from 'axios'

const origin = process.env.VUE_APP_API_ORIGIN
const responseData = response => response.data

/**
 * 祝日マスタ（全社共通）。**触れるのは運営だけ**（緊急最高管理者と、
 * PROVIDER_NOTICE_HOLIDAY_MANAGE を持つ運営管理者。2026-09-30）。
 *
 * 各社の休日カレンダーは「共通の祝日 ∪ 自社の上書き」で組み立てるので、
 * ここが埋まっていれば各社は祝日を入力しなくてよい。
 * 逆に、ここが切れると全社の祝日が黙って平日になる。
 */
export default {
  /** いつまで入っているか。年ごとの件数と、残り日数。 */
  status () {
    return axios.get(origin + '/platform-holidays').then(responseData)
  },

  /**
   * 内閣府のCSVを取り込む。
   *
   * @param csv 貼り付けられた本文
   * @param apply true なら本当に入れる。**既定は試すだけ。**
   */
  importCsv (csv, apply) {
    return axios.post(origin + '/platform-holidays/import', {
      csv,
      apply: apply === true
    }).then(responseData)
  }
}
